/*
 * COPYRIGHT Transtron Inc 2022
 *
 * 機能名：mqtt
 *
 * 作成者：2022/02/11 ノア）虞
 * 最終修正者：2022/02/11 ノア）虞
 *
 */
import * as mqtt from 'mqtt'

export interface MqttParams {
  /**
   * 接続先URL
   */
  servers: mqtt.IClientOptions['servers']
  /**
   * ユーザ名
   */
  username: string
  /**
   * パスワード
   */
  password: string
}

class MqttUtils {
  private client!: mqtt.Client

  private options: mqtt.IClientOptions = {
    reconnectPeriod: 1000,
    keepalive: 10
  }

  /**
   * パラメータを設定する
   *
   * @param {MqttParams} params パラメータ
   */
  initMqttConfig(params: MqttParams): void {
    this.options.servers = params.servers
    this.options.username = params.username
    this.options.password = params.password
  }

  /**
   * 接続
   *
   * @param {string[]} topics トピック
   * @param {any} callback コールバック
   */
  // eslint-disable-next-line
  connect(topics: string[], callback?: (data: any) => void) {
    const clientId = 'mqttjs_' + Math.random().toString(16).substr(2, 8)

    this.client = mqtt.connect({ clientId: clientId, ...this.options })

    this.client.on('connect', connack => {
      topics.forEach(topic => {
        this.client.subscribe(topic)
      })

      callback && callback(connack)
    })
  }

  /**
   * 切断する
   */
  end() {
    this.client?.end()
  }

  /**
   * リリース
   *
   * @param {string} topic トピック
   * @param {any} message メッセージ
   * @param {any} callback コールバック
   * @param {any} options オプション
   */
  // eslint-disable-next-line
  publish(topic: string, message: any, callback: (data: any) => void, options: any) {
    this.client.publish(topic, JSON.stringify(message), options, error => {
      callback && callback(error)
    })
  }

  /**
   * メッセージを受信する
   *
   * @param {string} topic トピック
   * @param {any} callback コールバック
   */
  // eslint-disable-next-line
  on(topic: string, callback: (data: any) => void) {
    this.client.on('message', (_topic, message) => {
      if (topic === _topic) {
        callback && callback(JSON.parse(message.toString()))
      }
    })
  }

  /**
   * 切断する
   *
   * @param {any} callback コールバック
   */
  onError(callback: () => void) {
    this.client.on('close', () => {
      callback && callback()
    })
  }
}

export default new MqttUtils()
